import React, { useState } from 'react'
import StatsTable from './StatsTable';
import StatRadarCharts from './StatRadarCharts';
import { useGetUserSessionQuery } from '../../../../services/api/userApi';
import { LockClosedIcon } from '@heroicons/react/20/solid';

const StatsView = ({game, sport, homeTeamLabel, awayTeamLabel}) => {
    const { data: userSessionData, isLoading: isUserSessionLoading, isError: isUserSessionError, isFetching: isUserSessionFetching } = useGetUserSessionQuery();
    const [dataType, setDataType] = useState('raw');
    const isSubActive = userSessionData?.isSubActive?.isActive;
    const dataTypeOptions = [
        { value: 'raw', label: 'Raw Averages' },
        { value: 'z', label: 'Z-Score' },
        { value: 'rank', label: 'League Rank', icon: isSubActive ? null : <LockClosedIcon width={15}/>, disabled: !isSubActive },
        { value: 'pct', label: 'Percentile', icon: isSubActive ? null : <LockClosedIcon width={15}/>, disabled: !isSubActive },
        { value: 'minmax', label: 'Min-Max', icon: isSubActive ? null : <LockClosedIcon width={15}/>, disabled: !isSubActive }
    ];
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="col-span-2 lg:col-span-1 max-h-[500px]">
                <StatsTable 
                    sport={sport} 
                    game={game} 
                    dataType={dataType} 
                    setDataType={setDataType}
                    dataTypeOptions={dataTypeOptions}
                    showCarets={true}
                />
            </div>
            {sport === "mlb" && (
                <>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Offensive Efficiency" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Hitting Splits" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts className="col-span-2 md:col-span-1" chartType="Offensive Production" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts className="col-span-2 md:col-span-1" chartType="Pitching Efficiency" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                </>
            )}
            {sport === "nfl" && (
                <>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Team Scoring" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Opponent Scoring" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Team Passing" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Opponent Passing" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Team Rushing" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Opponent Rushing" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Team Scheme" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Opponent Scheme" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                </>
            )}
            {sport === "nba" && (
                <>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Offensive Production" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Rebounding" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Playmaking & Control" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Scoring Efficiency" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                    <div className="col-span-2 lg:col-span-1">
                        <StatRadarCharts chartType="Shot Selection" homeTeamStats={game.home.normalized_stats} awayTeamStats={game.away.normalized_stats} sport={sport} homeTeamName={homeTeamLabel} awayTeamName={awayTeamLabel} dataType={dataType} />
                    </div>
                </>
            )}
        </div>
    )

}

export default StatsView